import { createContext, use } from 'react';
import invariant from 'tiny-invariant';

import type { DrawingManager } from '@cadstrom/renderer';

export type DrawingManagerContextValue = {
	drawingManager: DrawingManager | null;
	setDrawingManager: (drawingManager: DrawingManager | null) => void;
};

export const DrawingManagerContext = createContext<DrawingManagerContextValue | null>(null);
export const useDrawingManagerContext = () => {
	const value = use(DrawingManagerContext);
	invariant(value !== null, 'DrawingManagerContext not provided');
	return value;
};
